<div
  class="display-flex grid-gap-8 align-items-center"
  [matTooltip]="showFullName ? '' : fullName"
  [matTooltipShowDelay]="300"
>
  <div
    *ngIf="showIcon"
    class="avatar display-flex justify-content-center align-items-center"
    [ngClass]="[containerCss, avatarTheme]"
  >
    <ng-container *ngIf="firstName || lastName" [ngTemplateOutlet]="nameTemplate"></ng-container>
    <ng-container *ngIf="icon" [ngTemplateOutlet]="iconTemplate"></ng-container>
  </div>
  <ng-container *ngIf="showFullName" [ngTemplateOutlet]="fullNameTemplate"></ng-container>
</div>

<ng-template #nameTemplate>
  <div>{{ firstName | formatToAvatar: lastName }}</div>
</ng-template>

<ng-template #iconTemplate>
  <app-icon [svg]="icon" [iconWidth]="iconSize" [iconHeight]="iconSize"></app-icon>
</ng-template>

<ng-template #fullNameTemplate>
  <div class="body-small">{{ fullName }}</div>
</ng-template>
